"use client";
import { useMemo } from "react";
import keyBy from "lodash/keyBy";
import map from "lodash/map";

import CountryText from "@stadium/shared/src/components/country-text";

import { selectAllCountries } from "@stadium/redux-utils/selectors/configSelector";
import { useConfig } from "@stadium/hooks/lib/use-config";

export const useCountryMapping = () => {
  const countries = useConfig(selectAllCountries);

  const countryDropdownOptions = useMemo(
    () =>
      map(countries, (countryObj) => ({
        ...countryObj,
        text: <CountryText country={countryObj} />,
        value: countryObj?.iso,
      })),
    [countries],
  );

  const countriesMappingUsingIso = useMemo(
    () => keyBy(countryDropdownOptions, (countryObj) => countryObj.iso),
    [countryDropdownOptions],
  );

  return useMemo(
    () => ({
      countriesMappingUsingIso,
      countryDropdownOptions,
    }),
    [countryDropdownOptions],
  );
};
